export const Logo = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <rect width="80" height="80" fill="url(#pattern0_4326_10502)" />
      <defs>
        <pattern
          id="pattern0_4326_10502"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_4326_10502" transform="scale(0.0028169)" />
        </pattern>
        <image
          id="image0_4326_10502"
          width="355"
          height="355"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
export const Loader = (props) => {
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" {...props}>
      <path
        d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
        fill="#df1317"
        stroke="none"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        ></animateTransform>
      </path>
    </svg>
  );
};
export const Notifications = (props) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.89 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.36 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.63 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75Z"
        fill="white"
      />
    </svg>
  );
};
export const Avatar = ({ svgClass, className, props }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClass}
      {...props}
    >
      <rect
        width="32"
        height="32"
        rx="4"
        fill="#BDBDBD"
        className={className}
      />
      <path
        d="M16 16C18.21 16 20 14.21 20 12C20 9.79 18.21 8 16 8C13.79 8 12 9.79 12 12C12 14.21 13.79 16 16 16ZM16 18C13.33 18 8 19.34 8 22V24H24V22C24 19.34 18.67 18 16 18Z"
        fill="white"
      />
    </svg>
  );
};
export const ChatFilled = ({ fillClass, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM6 9H18V11H6V9ZM14 14H6V12H14V14ZM18 8H6V6H18V8Z"
        fill="white"
        className={fillClass}
      />
    </svg>
  );
};
export const Icon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4349_45014)">
        <path
          d="M20 6H10V12H8V4H14V0H6V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6Z"
          fill="white"
          {...props}
        />
      </g>
      <defs>
        <clipPath id="clip0_4349_45014">
          <rect width="24" height="24" fill="white" {...props} />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Vector = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ArrowUp = (props) => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.6087 11L4.6087 1.96395"
        stroke="#149D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.00004 4.55859L4.55764 1.001L8.11523 4.55859"
        stroke="#149D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowForward = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 0.5L6.59 1.91L12.17 7.5H0V9.5H12.17L6.59 15.09L8 16.5L16 8.5L8 0.5Z"
        fill="white"
      />
    </svg>
  );
};
export const TaskAltFilled = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const TaskList = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 0H1.99C0.89 0 0 0.9 0 2L0.00999999 16C0.00999999 17.1 0.9 18 2 18H12L18 12V2C18 0.9 17.1 0 16 0ZM4 5H14V7H4V5ZM9 11H4V9H9V11ZM11 16.5V11H16.5L11 16.5Z"
        fill="#065699"
      />
    </svg>
  );
};
export const ShoppingCart = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 16C4.9 16 4.01 16.9 4.01 18C4.01 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM0 0V2H2L5.6 9.59L4.25 12.04C4.09 12.32 4 12.65 4 13C4 14.1 4.9 15 6 15H18V13H6.42C6.28 13 6.17 12.89 6.17 12.75L6.2 12.63L7.1 11H14.55C15.3 11 15.96 10.59 16.3 9.97L19.88 3.48C19.96 3.34 20 3.17 20 3C20 2.45 19.55 2 19 2H4.21L3.27 0H0ZM16 16C14.9 16 14.01 16.9 14.01 18C14.01 19.1 14.9 20 16 20C17.1 20 18 19.1 18 18C18 16.9 17.1 16 16 16Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Plus = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8334 6.83464H6.83341V11.8346H5.16675V6.83464H0.166748V5.16797H5.16675V0.167969H6.83341V5.16797H11.8334V6.83464Z"
        fill="white"
        {...props}
      />
    </svg>
  );
};
export const Breadcrumbs = (props) => {
  return (
    <svg
      width="7"
      height="19"
      viewBox="0 0 7 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.672 0.927999L2.288 18.72H0.848L5.216 0.927999H6.672Z"
        fill="black"
        fillOpacity="0.6"
      />
    </svg>
  );
};
export const OutVector = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Search = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7549 11.2539H11.9649L11.6849 10.9839C12.6649 9.84391 13.2549 8.36391 13.2549 6.75391C13.2549 3.16391 10.3449 0.253906 6.75488 0.253906C3.16488 0.253906 0.254883 3.16391 0.254883 6.75391C0.254883 10.3439 3.16488 13.2539 6.75488 13.2539C8.36488 13.2539 9.84488 12.6639 10.9849 11.6839L11.2549 11.9639V12.7539L16.2549 17.7439L17.7449 16.2539L12.7549 11.2539ZM6.75488 11.2539C4.26488 11.2539 2.25488 9.24391 2.25488 6.75391C2.25488 4.26391 4.26488 2.25391 6.75488 2.25391C9.24488 2.25391 11.2549 4.26391 11.2549 6.75391C11.2549 9.24391 9.24488 11.2539 6.75488 11.2539Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Edit = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.499023 12.3771V15.5021H3.62402L12.8407 6.28542L9.71569 3.16042L0.499023 12.3771ZM15.2574 3.86875C15.5824 3.54375 15.5824 3.01875 15.2574 2.69375L13.3074 0.74375C12.9824 0.41875 12.4574 0.41875 12.1324 0.74375L10.6074 2.26875L13.7324 5.39375L15.2574 3.86875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Trash = (props) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.00008 13.8333C1.00008 14.75 1.75008 15.5 2.66675 15.5H9.33341C10.2501 15.5 11.0001 14.75 11.0001 13.8333V3.83333H1.00008V13.8333ZM3.05008 7.9L4.22508 6.725L6.00008 8.49167L7.76675 6.725L8.94175 7.9L7.17508 9.66667L8.94175 11.4333L7.76675 12.6083L6.00008 10.8417L4.23341 12.6083L3.05841 11.4333L4.82508 9.66667L3.05008 7.9ZM8.91675 1.33333L8.08341 0.5H3.91675L3.08341 1.33333H0.166748V3H11.8334V1.33333H8.91675Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const RippleLoaderSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200px"
    height="200px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-theme"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
    </circle>
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-theme"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
    </circle>
  </svg>
);
export const CancelCircle = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.20003 0.667969C4.5917 0.667969 0.866699 4.39297 0.866699 9.0013C0.866699 13.6096 4.5917 17.3346 9.20003 17.3346C13.8084 17.3346 17.5334 13.6096 17.5334 9.0013C17.5334 4.39297 13.8084 0.667969 9.20003 0.667969ZM13.3667 11.993L12.1917 13.168L9.20003 10.1763L6.20837 13.168L5.03337 11.993L8.02503 9.0013L5.03337 6.00964L6.20837 4.83464L9.20003 7.8263L12.1917 4.83464L13.3667 6.00964L10.375 9.0013L13.3667 11.993Z"
        fill="#C62828"
      />
    </svg>
  );
};
export const CheckCircleOutline = ({ pathClass, ...props }) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2077 5.44801L8.16683 11.4888L4.876 8.20717L3.5835 9.49967L8.16683 14.083L15.5002 6.74967L14.2077 5.44801ZM10.0002 0.333008C4.94016 0.333008 0.833496 4.43967 0.833496 9.49967C0.833496 14.5597 4.94016 18.6663 10.0002 18.6663C15.0602 18.6663 19.1668 14.5597 19.1668 9.49967C19.1668 4.43967 15.0602 0.333008 10.0002 0.333008ZM10.0002 16.833C5.9485 16.833 2.66683 13.5513 2.66683 9.49967C2.66683 5.44801 5.9485 2.16634 10.0002 2.16634C14.0518 2.16634 17.3335 5.44801 17.3335 9.49967C17.3335 13.5513 14.0518 16.833 10.0002 16.833Z"
        fill={"#2E7D6F"}
        className={pathClass}
      />
    </svg>
  );
};
export const CheckCircle = ({ pathClass, ...props }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.39974 0.667969C3.79974 0.667969 0.0664062 4.4013 0.0664062 9.0013C0.0664062 13.6013 3.79974 17.3346 8.39974 17.3346C12.9997 17.3346 16.7331 13.6013 16.7331 9.0013C16.7331 4.4013 12.9997 0.667969 8.39974 0.667969ZM6.73307 13.168L2.56641 9.0013L3.74141 7.8263L6.73307 10.8096L13.0581 4.48464L14.2331 5.66797L6.73307 13.168Z"
        fill="#2E7D6F"
        className={pathClass}
      />
    </svg>
  );
};
export const Close = ({ pathClass, fillOpacity, ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        className={pathClass}
      />
    </svg>
  );
};
export const People = (props) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V14H14V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C15.19 8.89 16 10.02 16 11.5V14H22V11.5C22 9.17 17.33 8 15 8Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const EngineeringOutlined = (props) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 12C5.33 12 0 13.34 0 16V18H16V16C16 13.34 10.67 12 8 12ZM2 16C2.22 15.28 5.31 14 8 14C10.7 14 13.8 15.29 14 16H2Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M3.74 6H4C4 8.21 5.79 10 8 10C10.21 10 12 8.21 12 6H12.26C12.53 6 12.75 5.78 12.75 5.51V5.49C12.75 5.22 12.53 5 12.26 5H12C12 3.52 11.19 2.25 10 1.55V2.5C10 2.78 9.78 3 9.5 3C9.22 3 9 2.78 9 2.5V1.14C8.68 1.06 8.35 1 8 1C7.65 1 7.32 1.06 7 1.14V2.5C7 2.78 6.78 3 6.5 3C6.22 3 6 2.78 6 2.5V1.55C4.81 2.25 4 3.52 4 5H3.74C3.47 5 3.25 5.22 3.25 5.49V5.52C3.25 5.78 3.47 6 3.74 6ZM10 6C10 7.1 9.1 8 8 8C6.9 8 6 7.1 6 6H10Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M20.9801 3.23L21.9101 2.4L21.1601 1.1L19.9701 1.49C19.8301 1.38 19.6701 1.29 19.5001 1.22L19.2501 0H17.7501L17.5001 1.22C17.3301 1.29 17.1701 1.38 17.0201 1.49L15.8401 1.1L15.0901 2.4L16.0201 3.23C16.0001 3.4 16.0001 3.58 16.0201 3.75L15.0901 4.6L15.8401 5.9L17.0401 5.52C17.1701 5.62 17.3201 5.7 17.4701 5.77L17.7501 7H19.2501L19.5201 5.78C19.6801 5.71 19.8201 5.63 19.9601 5.53L21.1501 5.91L21.9001 4.61L20.9701 3.76C21.0001 3.57 20.9901 3.4 20.9801 3.23ZM18.5001 4.75C17.8101 4.75 17.2501 4.19 17.2501 3.5C17.2501 2.81 17.8101 2.25 18.5001 2.25C19.1901 2.25 19.7501 2.81 19.7501 3.5C19.7501 4.19 19.1901 4.75 18.5001 4.75Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18.4001 7.79L17.5501 8.07C17.4501 7.99 17.3401 7.93 17.2201 7.88L17.0401 7H15.9701L15.7901 7.87C15.6701 7.92 15.5501 7.99 15.4501 8.06L14.6101 7.78L14.0701 8.71L14.7301 9.3C14.7201 9.43 14.7201 9.55 14.7301 9.67L14.0701 10.28L14.6101 11.21L15.4701 10.94C15.5701 11.01 15.6701 11.07 15.7801 11.12L15.9601 12H17.0301L17.2201 11.13C17.3301 11.08 17.4401 11.02 17.5401 10.95L18.3901 11.22L18.9301 10.29L18.2701 9.68C18.2801 9.55 18.2801 9.43 18.2701 9.31L18.9301 8.72L18.4001 7.79ZM16.5001 10.39C16.0101 10.39 15.6101 9.99 15.6101 9.5C15.6101 9.01 16.0101 8.61 16.5001 8.61C16.9901 8.61 17.3901 9.01 17.3901 9.5C17.3901 9.99 16.9901 10.39 16.5001 10.39Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const GroupsOutlined = (props) => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 7C5.1 7 6 6.1 6 5C6 3.9 5.1 3 4 3C2.9 3 2 3.9 2 5C2 6.1 2.9 7 4 7ZM5.13 8.1C4.76 8.04 4.39 8 4 8C3.01 8 2.07 8.21 1.22 8.58C0.48 8.9 0 9.62 0 10.43V12H4.5V10.39C4.5 9.56 4.73 8.78 5.13 8.1ZM20 7C21.1 7 22 6.1 22 5C22 3.9 21.1 3 20 3C18.9 3 18 3.9 18 5C18 6.1 18.9 7 20 7ZM24 10.43C24 9.62 23.52 8.9 22.78 8.58C21.93 8.21 20.99 8 20 8C19.61 8 19.24 8.04 18.87 8.1C19.27 8.78 19.5 9.56 19.5 10.39V12H24V10.43ZM16.24 7.65C15.07 7.13 13.63 6.75 12 6.75C10.37 6.75 8.93 7.14 7.76 7.65C6.68 8.13 6 9.21 6 10.39V12H18V10.39C18 9.21 17.32 8.13 16.24 7.65ZM8.07 10C8.16 9.77 8.2 9.61 8.98 9.31C9.95 8.93 10.97 8.75 12 8.75C13.03 8.75 14.05 8.93 15.02 9.31C15.79 9.61 15.83 9.77 15.93 10H8.07ZM12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4C11.45 4 11 3.55 11 3C11 2.45 11.45 2 12 2ZM12 0C10.34 0 9 1.34 9 3C9 4.66 10.34 6 12 6C13.66 6 15 4.66 15 3C15 1.34 13.66 0 12 0Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Work = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 4H14V2C14 0.89 13.11 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0.00999999 4.89 0.00999999 6L0 17C0 18.11 0.89 19 2 19H18C19.11 19 20 18.11 20 17V6C20 4.89 19.11 4 18 4ZM12 4H8V2H12V4Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const MarkUnreadMailbox = ({ fillOpacity, fillClass, ...props }) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 6H8V12H6V4H12V0H4V6H2C0.9 6 0 6.9 0 8V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        className={fillClass}
      />
    </svg>
  );
};
export const MoreVert = (props) => {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99992 3.66732C2.91659 3.66732 3.66659 2.91732 3.66659 2.00065C3.66659 1.08398 2.91659 0.333984 1.99992 0.333984C1.08325 0.333984 0.333252 1.08398 0.333252 2.00065C0.333252 2.91732 1.08325 3.66732 1.99992 3.66732ZM1.99992 5.33398C1.08325 5.33398 0.333252 6.08398 0.333252 7.00065C0.333252 7.91732 1.08325 8.66732 1.99992 8.66732C2.91659 8.66732 3.66659 7.91732 3.66659 7.00065C3.66659 6.08398 2.91659 5.33398 1.99992 5.33398ZM1.99992 10.334C1.08325 10.334 0.333252 11.084 0.333252 12.0007C0.333252 12.9173 1.08325 13.6673 1.99992 13.6673C2.91659 13.6673 3.66659 12.9173 3.66659 12.0007C3.66659 11.084 2.91659 10.334 1.99992 10.334Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Eye = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const EyeSlash = (props) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 2C6 2 1.73 5.11 0 9.5C1.73 13.89 6 17 11 17C16 17 20.27 13.89 22 9.5C20.27 5.11 16 2 11 2ZM11 14.5C8.24 14.5 6 12.26 6 9.5C6 6.74 8.24 4.5 11 4.5C13.76 4.5 16 6.74 16 9.5C16 12.26 13.76 14.5 11 14.5ZM11 6.5C9.34 6.5 8 7.84 8 9.5C8 11.16 9.34 12.5 11 12.5C12.66 12.5 14 11.16 14 9.5C14 7.84 12.66 6.5 11 6.5Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18 2L4 17"
        stroke="#707070"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const MailBox = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const User = ({ fillOpacity, pathClass, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        className={pathClass}
      />
    </svg>
  );
};
export const FileDownload = ({ fillColor, ...props }) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z"
        fill="#065699"
        className={fillColor}
      />
    </svg>
  );
};
export const FileUpload = (props) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_4634_16718)">
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          fill="white"
        />
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          stroke="#E0E0E0"
        />
        <path
          d="M20.165 23.3339C20.165 23.795 20.5388 24.1689 21 24.1689C21.4612 24.1689 21.835 23.795 21.835 23.3339H20.165ZM21.835 14.1672C21.835 13.706 21.4612 13.3322 21 13.3322C20.5388 13.3322 20.165 13.706 20.165 14.1672L21.835 14.1672ZM23.7429 16.4243C24.069 16.7504 24.5977 16.7504 24.9238 16.4243C25.2499 16.0982 25.2499 15.5695 24.9238 15.2434L23.7429 16.4243ZM21.5893 13.0898L20.9988 13.6802L21.5893 13.0898ZM20.4107 13.0898L21.0012 13.6802L21.0012 13.6802L20.4107 13.0898ZM17.0762 15.2434C16.7501 15.5695 16.7501 16.0982 17.0762 16.4243C17.4023 16.7504 17.931 16.7504 18.2571 16.4243L17.0762 15.2434ZM14.335 23.3339C14.335 22.8727 13.9612 22.4989 13.5 22.4989C13.0388 22.4989 12.665 22.8727 12.665 23.3339H14.335ZM29.335 23.3339C29.335 22.8727 28.9612 22.4989 28.5 22.4989C28.0388 22.4989 27.665 22.8727 27.665 23.3339H29.335ZM27.135 27.228L26.7559 26.4841H26.7559L27.135 27.228ZM28.2275 26.1355L28.9715 26.5146V26.5146L28.2275 26.1355ZM13.7725 26.1355L13.0285 26.5146L13.7725 26.1355ZM14.865 27.228L14.4859 27.972H14.4859L14.865 27.228ZM21.835 23.3339L21.835 14.1672L20.165 14.1672L20.165 23.3339H21.835ZM24.9238 15.2434L22.1797 12.4993L20.9988 13.6802L23.7429 16.4243L24.9238 15.2434ZM19.8203 12.4993L17.0762 15.2434L18.2571 16.4243L21.0012 13.6802L19.8203 12.4993ZM22.1797 12.4993C21.5282 11.8478 20.4718 11.8478 19.8203 12.4993L21.0012 13.6802C21.0021 13.6793 21.0016 13.68 21.0002 13.6805C20.9994 13.6808 20.9994 13.6807 21 13.6807C21.0006 13.6807 21.0006 13.6808 20.9998 13.6805C20.9984 13.68 20.9979 13.6793 20.9988 13.6802L22.1797 12.4993ZM12.665 23.3339V23.5005H14.335V23.3339H12.665ZM17.5 28.3355H24.5V26.6655H17.5V28.3355ZM29.335 23.5005V23.3339H27.665V23.5005H29.335ZM24.5 28.3355C25.1863 28.3355 25.7512 28.3362 26.21 28.2987C26.6785 28.2604 27.1093 28.1782 27.5141 27.972L26.7559 26.4841C26.6258 26.5503 26.4392 26.6044 26.074 26.6342C25.699 26.6649 25.2138 26.6655 24.5 26.6655V28.3355ZM27.665 23.5005C27.665 24.2144 27.6644 24.6995 27.6337 25.0745C27.6039 25.4398 27.5498 25.6264 27.4835 25.7564L28.9715 26.5146C29.1777 26.1099 29.2599 25.679 29.2982 25.2105C29.3356 24.7517 29.335 24.1868 29.335 23.5005H27.665ZM27.5141 27.972C28.1416 27.6523 28.6518 27.1421 28.9715 26.5146L27.4835 25.7564C27.3239 26.0697 27.0692 26.3244 26.7559 26.4841L27.5141 27.972ZM12.665 23.5005C12.665 24.1868 12.6644 24.7517 12.7018 25.2105C12.7401 25.679 12.8223 26.1099 13.0285 26.5146L14.5165 25.7564C14.4502 25.6264 14.3961 25.4398 14.3663 25.0745C14.3356 24.6995 14.335 24.2144 14.335 23.5005H12.665ZM17.5 26.6655C16.7862 26.6655 16.301 26.6649 15.926 26.6342C15.5608 26.6044 15.3742 26.5503 15.2441 26.4841L14.4859 27.972C14.8907 28.1782 15.3215 28.2604 15.79 28.2987C16.2488 28.3362 16.8137 28.3355 17.5 28.3355V26.6655ZM13.0285 26.5146C13.3482 27.1421 13.8584 27.6523 14.4859 27.972L15.2441 26.4841C14.9308 26.3244 14.6761 26.0697 14.5165 25.7564L13.0285 26.5146Z"
          fill="black"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4634_16718"
          x="0.5"
          y="0.5"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4634_16718"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4634_16718"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const PDFDoc = (props) => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0003 5.85325V34.2769C27.0003 34.9505 26.4518 35.5 25.7795 35.5H3.27358C2.60123 35.5 2.05273 34.9505 2.05273 34.2769V1.72309C2.05273 1.04951 2.60123 0.5 3.27358 0.5H21.6481L27.0003 5.85325Z"
        fill="white"
      />
      <path
        d="M27.0002 5.85325V34.2769C27.0002 34.9505 26.4517 35.5 25.7794 35.5H24.0366C24.7089 35.5 25.2574 34.9505 25.2574 34.2769V5.85325L19.9141 0.5H21.6569L27.0002 5.85325Z"
        fill="#E5E5E5"
      />
      <path
        d="M26.9997 5.85325H22.8683C22.196 5.85325 21.6475 5.30375 21.6475 4.63016V0.5L26.9997 5.85325Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 17.0734H7.35146C6.8649 17.0734 6.4668 16.6745 6.4668 16.1871C6.4668 15.6996 6.8649 15.3008 7.35146 15.3008H21.8423C22.3289 15.3008 22.727 15.6996 22.727 16.1871C22.727 16.6834 22.3377 17.0734 21.8423 17.0734Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 21.6203H7.35146C6.8649 21.6203 6.4668 21.2214 6.4668 20.734C6.4668 20.2465 6.8649 19.8477 7.35146 19.8477H21.8423C22.3289 19.8477 22.727 20.2465 22.727 20.734C22.727 21.2303 22.3377 21.6203 21.8423 21.6203Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 26.1671H7.35146C6.8649 26.1671 6.4668 25.7683 6.4668 25.2808C6.4668 24.7934 6.8649 24.3945 7.35146 24.3945H21.8423C22.3289 24.3945 22.727 24.7934 22.727 25.2808C22.727 25.7772 22.3377 26.1671 21.8423 26.1671Z"
        fill="#CECECE"
      />
      <path
        d="M12.2526 12.4651H0V7.493C0 7.12075 0.300782 6.81055 0.681188 6.81055H12.2526C12.6242 6.81055 12.9338 7.11189 12.9338 7.493V11.7827C12.9338 12.1549 12.633 12.4651 12.2526 12.4651Z"
        fill="#F55B4B"
      />
      <path
        d="M12.9338 11.6941V11.7827C12.9338 12.1549 12.633 12.4651 12.2526 12.4651H0V7.493C0 7.12075 0.300782 6.81055 0.681188 6.81055H1.02621V8.58315C1.02621 10.3026 2.41514 11.7029 4.14023 11.7029H12.9338V11.6941Z"
        fill="#DD4E43"
      />
      <path d="M0 12.4648L2.05242 14.8047V12.4648H0Z" fill="#DB1B1B" />
      <path
        d="M3.3177 10.7099V11.3038H1.46875V10.7099H1.91993V8.37898H1.46875V7.78516H3.3177C3.75119 7.78516 4.07852 7.88265 4.31738 8.0865C4.55624 8.29035 4.67124 8.5651 4.67124 8.9019C4.67124 9.09688 4.62701 9.27414 4.54739 9.43368C4.46777 9.59321 4.36161 9.71729 4.22891 9.79706C4.09621 9.88569 3.95466 9.93887 3.78658 9.97432C3.61849 10.0098 3.41502 10.0186 3.16731 10.0186H2.83114V10.7011H3.3177V10.7099ZM2.83114 9.43368H2.96384C3.27347 9.43368 3.47694 9.3805 3.56541 9.283C3.65388 9.18551 3.69811 9.05257 3.69811 8.9019C3.69811 8.77781 3.66272 8.66259 3.60079 8.57396C3.53887 8.48533 3.4681 8.43216 3.38848 8.40557C3.30886 8.38784 3.17616 8.37011 2.99038 8.37011H2.82229V9.43368H2.83114Z"
        fill="white"
      />
      <path
        d="M4.88379 11.3038V10.7099H5.41459V8.37898H4.88379V7.78516H6.54697C6.90083 7.78516 7.17508 7.80288 7.39624 7.8472C7.60856 7.89151 7.81204 7.989 8.00666 8.13081C8.20129 8.28148 8.36053 8.47647 8.47554 8.72464C8.59054 8.9728 8.65247 9.24755 8.65247 9.54889C8.65247 9.79706 8.60823 10.0275 8.52861 10.2491C8.44899 10.4706 8.34283 10.6479 8.21898 10.7897C8.09513 10.9227 7.95358 11.0379 7.77665 11.1176C7.60856 11.1974 7.44932 11.2506 7.30778 11.2772C7.16623 11.3038 6.94506 11.3126 6.64428 11.3126H4.88379V11.3038ZM6.33464 10.7099H6.55581C6.82121 10.7099 7.03353 10.6745 7.19277 10.6036C7.35201 10.5327 7.47586 10.4086 7.56433 10.2402C7.66164 10.0629 7.70588 9.84137 7.70588 9.55776C7.70588 9.29187 7.66164 9.06143 7.56433 8.87531C7.46702 8.68918 7.34316 8.55624 7.17508 8.48533C7.01584 8.41443 6.80352 8.37898 6.55581 8.37898H6.33464V10.7099Z"
        fill="white"
      />
      <path
        d="M9.05957 11.3038V10.7099H9.56383V8.37898H9.05957V7.78516H12.209V8.87531H11.5366V8.38784H10.4839V9.20324H11.2447V9.79706H10.4839V10.7099H11.0235V11.3038H9.05957Z"
        fill="white"
      />
      <path
        d="M10.9082 14.1134H2.06152V12.4648H12.2971V12.7307C12.2883 13.493 11.669 14.1134 10.9082 14.1134Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};
export const CompaniesIcon = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z"
        fill="black"
        fillOpacity="0.54"
        {...props}
      />
    </svg>
  );
};
export const Folder = (props) => {
  return (
    <svg
      width="80"
      height="64"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.1663 0.666992H8.66634C4.35801 0.666992 0.872174 4.19199 0.872174 8.50033L0.833008 55.5003C0.833008 59.8087 4.35801 63.3337 8.66634 63.3337H71.333C75.6413 63.3337 79.1663 59.8087 79.1663 55.5003V16.3337C79.1663 12.0253 75.6413 8.50033 71.333 8.50033H39.9997L32.1663 0.666992Z"
        fill="#065699"
      />
    </svg>
  );
};
export const UpArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.296875L0 6.29688L1.41 7.70687L6 3.12687L10.59 7.70687L12 6.29688L6 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DownArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70687L6 7.70687L12 1.70687L10.59 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const BackArrow = ({ fillOpacity, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        {...props}
      />
    </svg>
  );
};
export const Campaign = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7V9H20V7H16ZM14 13.61C14.96 14.32 16.21 15.26 17.2 16C17.6 15.47 18 14.93 18.4 14.4C17.41 13.66 16.16 12.72 15.2 12C14.8 12.54 14.4 13.08 14 13.61ZM18.4 1.6C18 1.07 17.6 0.53 17.2 0C16.21 0.74 14.96 1.68 14 2.4C14.4 2.93 14.8 3.47 15.2 4C16.16 3.28 17.41 2.35 18.4 1.6ZM2 5C0.9 5 0 5.9 0 7V9C0 10.1 0.9 11 2 11H3V15H5V11H6L11 14V2L6 5H2ZM13.5 8C13.5 6.67 12.92 5.47 12 4.65V11.34C12.92 10.53 13.5 9.33 13.5 8Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Star = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 15.77L16.18 19.5L14.54 12.47L20 7.74L12.81 7.13L10 0.5L7.19 7.13L0 7.74L5.46 12.47L3.82 19.5L10 15.77Z"
        fill="#065699"
      />
    </svg>
  );
};
export const Location = (props) => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z"
        fill="#065699"
      />
    </svg>
  );
};
export const Settings = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1401 10.9384C17.1801 10.6384 17.2001 10.3284 17.2001 9.99844C17.2001 9.67844 17.1801 9.35844 17.1301 9.05844L19.1601 7.47844C19.3401 7.33844 19.3901 7.06844 19.2801 6.86844L17.3601 3.54844C17.2401 3.32844 16.9901 3.25844 16.7701 3.32844L14.3801 4.28844C13.8801 3.90844 13.3501 3.58844 12.7601 3.34844L12.4001 0.808437C12.3601 0.568437 12.1601 0.398438 11.9201 0.398438H8.08011C7.84011 0.398438 7.65011 0.568437 7.61011 0.808437L7.25011 3.34844C6.66011 3.58844 6.12011 3.91844 5.63011 4.28844L3.24011 3.32844C3.02011 3.24844 2.77011 3.32844 2.65011 3.54844L0.74011 6.86844C0.62011 7.07844 0.66011 7.33844 0.86011 7.47844L2.89011 9.05844C2.84011 9.35844 2.80011 9.68844 2.80011 9.99844C2.80011 10.3084 2.82011 10.6384 2.87011 10.9384L0.84011 12.5184C0.66011 12.6584 0.61011 12.9284 0.72011 13.1284L2.64011 16.4484C2.76011 16.6684 3.01011 16.7384 3.23011 16.6684L5.62011 15.7084C6.12011 16.0884 6.65011 16.4084 7.24011 16.6484L7.60011 19.1884C7.65011 19.4284 7.84011 19.5984 8.08011 19.5984H11.9201C12.1601 19.5984 12.3601 19.4284 12.3901 19.1884L12.7501 16.6484C13.3401 16.4084 13.8801 16.0884 14.3701 15.7084L16.7601 16.6684C16.9801 16.7484 17.2301 16.6684 17.3501 16.4484L19.2701 13.1284C19.3901 12.9084 19.3401 12.6584 19.1501 12.5184L17.1401 10.9384ZM10.0001 13.5984C8.02011 13.5984 6.40011 11.9784 6.40011 9.99844C6.40011 8.01844 8.02011 6.39844 10.0001 6.39844C11.9801 6.39844 13.6001 8.01844 13.6001 9.99844C13.6001 11.9784 11.9801 13.5984 10.0001 13.5984Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const General = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.89 0 0 0.89 0 2V14C0 15.1 0.89 16 2 16H6V18H14V16H18C19.1 16 20 15.1 20 14V2C20 0.89 19.1 0 18 0ZM18 14H2V2H18V14Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path d="M12 5.25H4V6.75H12V5.25Z" fill="black" fillOpacity="0.54" />
      <path
        d="M14.5 6.75H16V5.25H14.5V4H13V8H14.5V6.75Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path d="M16 9.25H8V10.75H16V9.25Z" fill="black" fillOpacity="0.54" />
      <path
        d="M5.5 12H7V8H5.5V9.25H4V10.75H5.5V12Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Service = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4V2H8V4H12ZM2 6V17H18V6H2ZM18 4C19.11 4 20 4.89 20 6V17C20 18.11 19.11 19 18 19H2C0.89 19 0 18.11 0 17L0.00999999 6C0.00999999 4.89 0.89 4 2 4H6V2C6 0.89 6.89 0 8 0H12C13.11 0 14 0.89 14 2V4H18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ActivityLog = (props) => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0C7.03 0 3 4.03 3 9H0L3.89 12.89L3.96 13.03L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.07 16 8.32 15.21 7.06 13.94L5.64 15.36C7.27 16.99 9.51 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0ZM11 5V10L15.28 12.54L16 11.33L12.5 9.25V5H11Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Send = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0114286 24L24 12L0.0114286 0L0 9.33333L17.1429 12L0 14.6667L0.0114286 24Z"
        fill="#065699"
      />
    </svg>
  );
};
export const ImgSearchIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 11V18H2V4H7.02C7.07 3.29 7.24 2.62 7.5 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V13L16 11ZM14.5 16H3.5L6.25 12.47L8.21 14.83L10.96 11.29L14.5 16ZM17.3 6.89C17.74 6.19 18 5.38 18 4.5C18 2.01 15.99 0 13.5 0C11.01 0 9 2.01 9 4.5C9 6.99 11.01 9 13.49 9C14.37 9 15.19 8.74 15.88 8.3L19 11.42L20.42 10L17.3 6.89ZM13.5 7C12.12 7 11 5.88 11 4.5C11 3.12 12.12 2 13.5 2C14.88 2 16 3.12 16 4.5C16 5.88 14.88 7 13.5 7Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ImgIcon = (props) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.7917 2.70833V17.2917H2.20833V2.70833H16.7917ZM16.7917 0.625H2.20833C1.0625 0.625 0.125 1.5625 0.125 2.70833V17.2917C0.125 18.4375 1.0625 19.375 2.20833 19.375H16.7917C17.9375 19.375 18.875 18.4375 18.875 17.2917V2.70833C18.875 1.5625 17.9375 0.625 16.7917 0.625ZM11.7292 9.85417L8.60417 13.8854L6.375 11.1875L3.25 15.2083H15.75L11.7292 9.85417Z"
        fill="#065699"
        fillOpacity="0.5"
      />
    </svg>
  );
};
export const PDFFileIcon = (props) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8333 0.582031H6.33325C5.18742 0.582031 4.24992 1.51953 4.24992 2.66536V15.1654C4.24992 16.3112 5.18742 17.2487 6.33325 17.2487H18.8333C19.9791 17.2487 20.9166 16.3112 20.9166 15.1654V2.66536C20.9166 1.51953 19.9791 0.582031 18.8333 0.582031ZM9.97908 8.39453C9.97908 9.25911 9.28117 9.95703 8.41658 9.95703H7.37492V12.0404H5.81242V5.79036H8.41658C9.28117 5.79036 9.97908 6.48828 9.97908 7.35286V8.39453ZM15.1874 10.4779C15.1874 11.3424 14.4895 12.0404 13.6249 12.0404H11.0208V5.79036H13.6249C14.4895 5.79036 15.1874 6.48828 15.1874 7.35286V10.4779ZM19.3541 7.35286H17.7916V8.39453H19.3541V9.95703H17.7916V12.0404H16.2291V5.79036H19.3541V7.35286ZM7.37492 8.39453H8.41658V7.35286H7.37492V8.39453ZM2.16659 4.7487H0.083252V19.332C0.083252 20.4779 1.02075 21.4154 2.16659 21.4154H16.7499V19.332H2.16659V4.7487ZM12.5833 10.4779H13.6249V7.35286H12.5833V10.4779Z"
        fill="#EF5350"
      />
    </svg>
  );
};
export const MoneyApprovedCreditcardIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.625 26.375H3.125C2.66087 26.375 2.21575 26.1906 1.88756 25.8624C1.55937 25.5342 1.375 25.0891 1.375 24.625V3.625C1.375 3.16087 1.55937 2.71575 1.88756 2.38756C2.21575 2.05937 2.66087 1.875 3.125 1.875H32.875C33.3391 1.875 33.7842 2.05937 34.1124 2.38756C34.4406 2.71575 34.625 3.16087 34.625 3.625V24.625C34.625 25.0891 34.4406 25.5342 34.1124 25.8624C33.7842 26.1906 33.3391 26.375 32.875 26.375H29.375"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 21.125L16.25 26.375L13.625 23.75"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.75 6.25V11.5H11V6.25H5.75Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 7.125H16.25"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75 7.125H21.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 7.125H26.75"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.375 10.625H26.75"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 10.625H18.875"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 34.25L23.355 31.0388C24.3909 30.4164 25.248 29.5365 25.8429 28.4846C26.4379 27.4327 26.7504 26.2447 26.75 25.0362V17.625L18 14.125L9.25 17.625V25.0362C9.24963 26.2447 9.56211 27.4327 10.1571 28.4846C10.752 29.5365 11.6091 30.4164 12.645 31.0388L18 34.25Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BusinessBuilding = (props) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.625 18.375L21 3.5L4.375 18.375"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M33.25 29.75V38.5H8.75V29.75"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 30.625H12.25V38.5H17.5V30.625Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M29.75 30.625H21V35H29.75V30.625Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21 14C22.933 14 24.5 13.2165 24.5 12.25C24.5 11.2835 22.933 10.5 21 10.5C19.067 10.5 17.5 11.2835 17.5 12.25C17.5 13.2165 19.067 14 21 14Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 18.375V14"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M32.375 18.375V14"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 18.375L7 23.625H35L32.375 18.375H9.625Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M14 23.625L15.75 18.375"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 18.375L28 23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21 18.375V23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7 23.625V24.5C7 25.4283 7.36875 26.3185 8.02513 26.9749C8.6815 27.6313 9.57174 28 10.5 28C11.4283 28 12.3185 27.6313 12.9749 26.9749C13.6313 26.3185 14 25.4283 14 24.5V23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M14 23.625V24.5C14 25.4283 14.3687 26.3185 15.0251 26.9749C15.6815 27.6313 16.5717 28 17.5 28C18.4283 28 19.3185 27.6313 19.9749 26.9749C20.6313 26.3185 21 25.4283 21 24.5V23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21 23.625V24.5C21 25.4283 21.3687 26.3185 22.0251 26.9749C22.6815 27.6313 23.5717 28 24.5 28C25.4283 28 26.3185 27.6313 26.9749 26.9749C27.6313 26.3185 28 25.4283 28 24.5V23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M28 23.625V24.5C28 25.4283 28.3687 26.3185 29.0251 26.9749C29.6815 27.6313 30.5717 28 31.5 28C32.4283 28 33.3185 27.6313 33.9749 26.9749C34.6313 26.3185 35 25.4283 35 24.5V23.625"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HouseSearch = (props) => {
  return (
    <svg
      width="44"
      height="41"
      viewBox="0 0 44 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 36C25.3137 36 28 33.3137 28 30C28 26.6863 25.3137 24 22 24C18.6863 24 16 26.6863 16 30C16 33.3137 18.6863 36 22 36Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17.65 34.3516L12 40.0016"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 17V30H11"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 30V12L22 1L11 12V30"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 14C19 13.2044 19.3161 12.4413 19.8787 11.8787C20.4413 11.3161 21.2044 11 22 11C22.7956 11 23.5587 11.3161 24.1213 11.8787C24.6839 12.4413 25 13.2044 25 14"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21V18H25V21"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 16L4 7H16"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16H1"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 7H40L43 16H34"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 17V30H33"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Info = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM11 15.5H9V13.5H11V15.5ZM11 11.5H9V5.5H11V11.5Z"
        fill="#0288D1"
      />
    </svg>
  );
};
export const CreateNewFolderIcon = (props) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 2.5H10L8 0.5H2C0.89 0.5 0.00999999 1.39 0.00999999 2.5L0 14.5C0 15.61 0.89 16.5 2 16.5H18C19.11 16.5 20 15.61 20 14.5V4.5C20 3.39 19.11 2.5 18 2.5ZM17 10.5H14V13.5H12V10.5H9V8.5H12V5.5H14V8.5H17V10.5Z"
        fill="white"
      />
    </svg>
  );
};
export const LoaderSvg = ({ pathClass, ...props }) => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className="inline w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
        className={pathClass}
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
        className={pathClass}
      ></path>
    </svg>
  );
};
export const RoundInfo = (props) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM13 17.5H11V15.5H13V17.5ZM13 13.5H11V7.5H13V13.5Z"
        fill="#0288D1"
      />
    </svg>
  );
};
export const UserIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.0026 7.00065C8.84427 7.00065 10.3359 5.50898 10.3359 3.66732C10.3359 1.82565 8.84427 0.333984 7.0026 0.333984C5.16094 0.333984 3.66927 1.82565 3.66927 3.66732C3.66927 5.50898 5.16094 7.00065 7.0026 7.00065ZM7.0026 8.66732C4.7776 8.66732 0.335938 9.78398 0.335938 12.0007V13.6673H13.6693V12.0007C13.6693 9.78398 9.2276 8.66732 7.0026 8.66732Z"
        fill="white"
      />
    </svg>
  );
};
export const PDF = () => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0023 5.85325V34.2769C27.0023 34.9505 26.4538 35.5 25.7814 35.5H3.27553C2.60318 35.5 2.05469 34.9505 2.05469 34.2769V1.72309C2.05469 1.04951 2.60318 0.5 3.27553 0.5H21.65L27.0023 5.85325Z"
        fill="white"
      />
      <path
        d="M27.0002 5.85325V34.2769C27.0002 34.9505 26.4517 35.5 25.7794 35.5H24.0366C24.7089 35.5 25.2574 34.9505 25.2574 34.2769V5.85325L19.9141 0.5H21.6569L27.0002 5.85325Z"
        fill="#E5E5E5"
      />
      <path
        d="M27.0007 5.85325H22.8693C22.1969 5.85325 21.6484 5.30375 21.6484 4.63016V0.5L27.0007 5.85325Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 17.0773H7.35342C6.86685 17.0773 6.46875 16.6785 6.46875 16.191C6.46875 15.7035 6.86685 15.3047 7.35342 15.3047H21.8442C22.3308 15.3047 22.7289 15.7035 22.7289 16.191C22.7289 16.6873 22.3397 17.0773 21.8442 17.0773Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 21.6242H7.35342C6.86685 21.6242 6.46875 21.2253 6.46875 20.7379C6.46875 20.2504 6.86685 19.8516 7.35342 19.8516H21.8442C22.3308 19.8516 22.7289 20.2504 22.7289 20.7379C22.7289 21.2342 22.3397 21.6242 21.8442 21.6242Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 26.171H7.35342C6.86685 26.171 6.46875 25.7722 6.46875 25.2847C6.46875 24.7973 6.86685 24.3984 7.35342 24.3984H21.8442C22.3308 24.3984 22.7289 24.7973 22.7289 25.2847C22.7289 25.7811 22.3397 26.171 21.8442 26.171Z"
        fill="#CECECE"
      />
      <path
        d="M12.2526 12.4671H0V7.49495C0 7.1227 0.300782 6.8125 0.681188 6.8125H12.2526C12.6242 6.8125 12.9338 7.11384 12.9338 7.49495V11.7846C12.9338 12.1569 12.633 12.4671 12.2526 12.4671Z"
        fill="#F55B4B"
      />
      <path
        d="M12.9338 11.696V11.7846C12.9338 12.1569 12.633 12.4671 12.2526 12.4671H0V7.49495C0 7.1227 0.300782 6.8125 0.681188 6.8125H1.02621V8.5851C1.02621 10.3045 2.41514 11.7049 4.14023 11.7049H12.9338V11.696Z"
        fill="#DD4E43"
      />
      <path d="M0 12.4688L2.05242 14.8086V12.4688H0Z" fill="#DB1B1B" />
      <path
        d="M3.3177 10.7139V11.3077H1.46875V10.7139H1.91993V8.38288H1.46875V7.78906H3.3177C3.75119 7.78906 4.07852 7.88655 4.31738 8.0904C4.55624 8.29425 4.67124 8.56901 4.67124 8.9058C4.67124 9.10079 4.62701 9.27805 4.54739 9.43758C4.46777 9.59712 4.36161 9.7212 4.22891 9.80096C4.09621 9.88959 3.95466 9.94277 3.78658 9.97822C3.61849 10.0137 3.41502 10.0225 3.16731 10.0225H2.83114V10.705H3.3177V10.7139ZM2.83114 9.43758H2.96384C3.27347 9.43758 3.47694 9.3844 3.56541 9.28691C3.65388 9.18942 3.69811 9.05647 3.69811 8.9058C3.69811 8.78172 3.66272 8.6665 3.60079 8.57787C3.53887 8.48924 3.4681 8.43606 3.38848 8.40947C3.30886 8.39175 3.17616 8.37402 2.99038 8.37402H2.82229V9.43758H2.83114Z"
        fill="white"
      />
      <path
        d="M4.88281 11.3077V10.7139H5.41361V8.38288H4.88281V7.78906H6.54599C6.89986 7.78906 7.1741 7.80679 7.39527 7.8511C7.60759 7.89542 7.81106 7.99291 8.00569 8.13472C8.20031 8.28539 8.35955 8.48038 8.47456 8.72854C8.58957 8.97671 8.65149 9.25146 8.65149 9.5528C8.65149 9.80096 8.60726 10.0314 8.52764 10.253C8.44802 10.4746 8.34186 10.6518 8.218 10.7936C8.09415 10.9266 7.9526 11.0418 7.77567 11.1216C7.60758 11.2013 7.44835 11.2545 7.3068 11.2811C7.16525 11.3077 6.94409 11.3165 6.6433 11.3165H4.88281V11.3077ZM6.33367 10.7139H6.55483C6.82023 10.7139 7.03255 10.6784 7.19179 10.6075C7.35103 10.5366 7.47489 10.4125 7.56335 10.2441C7.66067 10.0669 7.7049 9.84528 7.7049 9.56166C7.7049 9.29577 7.66067 9.06534 7.56335 8.87921C7.46604 8.69309 7.34219 8.56014 7.1741 8.48924C7.01486 8.41834 6.80254 8.38288 6.55483 8.38288H6.33367V10.7139Z"
        fill="white"
      />
      <path
        d="M9.0625 11.3077V10.7139H9.56676V8.38288H9.0625V7.78906H12.2119V8.87921H11.5396V8.39175H10.4868V9.20714H11.2476V9.80096H10.4868V10.7139H11.0265V11.3077H9.0625Z"
        fill="white"
      />
      <path
        d="M10.9092 14.1173H2.0625V12.4688H12.2981V12.7346C12.2892 13.4969 11.67 14.1173 10.9092 14.1173Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};
export const Undo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <g opacity="0.6">
        <path
          d="M10.4 9.4C8.7 9.7 7.2 10.3 5.8 11.4L3 8.5V15.5H10L7.3 12.8C11 10.2 16.1 11 18.8 14.7C19 15 19.2 15.2 19.3 15.5L21.1 14.6C18.9 10.8 14.7 8.7 10.4 9.4Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export const Redo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <g opacity="0.6">
        <path
          d="M13.6 9.4C15.3 9.7 16.8 10.3 18.2 11.4L21 8.5V15.5H14L16.7 12.8C13 10.1 7.9 11 5.3 14.7C5.1 15 4.9 15.2 4.8 15.5L3 14.6C5.1 10.8 9.3 8.7 13.6 9.4Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export const Bold = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M15.2484 11.8C15.7381 11.5018 16.1513 11.0934 16.4551 10.6073C16.7589 10.1212 16.945 9.57077 16.9984 9C17.0077 8.48388 16.9152 7.971 16.7262 7.49063C16.5373 7.01027 16.2555 6.57184 15.8971 6.20039C15.5386 5.82894 15.1105 5.53174 14.6372 5.32578C14.1638 5.11981 13.6546 5.00911 13.1384 5H6.64844V19H13.6484C14.1396 18.9948 14.6249 18.8929 15.0767 18.7001C15.5284 18.5073 15.9378 18.2274 16.2814 17.8764C16.6249 17.5253 16.896 17.1101 17.0791 16.6543C17.2622 16.1985 17.3537 15.7112 17.3484 15.22V15.1C17.3488 14.4071 17.1514 13.7285 16.7794 13.144C16.4074 12.5594 15.8763 12.0931 15.2484 11.8ZM8.64844 7H12.8484C13.2746 6.98681 13.6946 7.10428 14.0521 7.33665C14.4096 7.56902 14.6875 7.90517 14.8484 8.3C15.0113 8.82779 14.9586 9.39859 14.7019 9.88765C14.4452 10.3767 14.0053 10.7443 13.4784 10.91C13.2738 10.97 13.0617 11.0003 12.8484 11H8.64844V7ZM13.2484 17H8.64844V13H13.2484C13.6746 12.9868 14.0946 13.1043 14.4521 13.3367C14.8096 13.569 15.0875 13.9052 15.2484 14.3C15.4113 14.8278 15.3586 15.3986 15.1019 15.8877C14.8452 16.3767 14.4053 16.7443 13.8784 16.91C13.6738 16.97 13.4617 17.0003 13.2484 17Z"
        fill="black"
      />
    </svg>
  );
};
export const Underline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M19 20V22H5V20H19ZM16 13.215C15.9671 13.875 15.7711 14.5165 15.4297 15.0823C15.0883 15.6481 14.6121 16.1205 14.0435 16.4572C13.475 16.794 12.8318 16.9847 12.1716 17.0122C11.5114 17.0397 10.8546 16.9033 10.26 16.615C9.57464 16.3185 8.99341 15.8241 8.59077 15.1952C8.18813 14.5663 7.98242 13.8315 8 13.085V5.005H6V13.215C6.03383 14.1564 6.28885 15.0766 6.74442 15.9012C7.19998 16.7257 7.84329 17.4314 8.62227 17.9611C9.40125 18.4908 10.294 18.8296 11.2283 18.9502C12.1625 19.0707 13.1121 18.9696 14 18.655C15.1811 18.2613 16.2059 17.5012 16.9252 16.485C17.6446 15.4689 18.0211 14.2498 18 13.005V5.005H16V13.215ZM16 5H18H16ZM8 5H6H8Z"
        fill="black"
      />
    </svg>
  );
};
export const Link = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M11 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7H11V9H7C6.20435 9 5.44129 9.31607 4.87868 9.87868C4.31607 10.4413 4 11.2044 4 12C4 12.7956 4.31607 13.5587 4.87868 14.1213C5.44129 14.6839 6.20435 15 7 15H11V17ZM17 7H13V9H17C17.7956 9 18.5587 9.31607 19.1213 9.87868C19.6839 10.4413 20 11.2044 20 12C20 12.7956 19.6839 13.5587 19.1213 14.1213C18.5587 14.6839 17.7956 15 17 15H13V17H17C18.3261 17 19.5979 16.4732 20.5355 15.5355C21.4732 14.5979 22 13.3261 22 12C22 10.6739 21.4732 9.40215 20.5355 8.46447C19.5979 7.52678 18.3261 7 17 7ZM16 11H8V13H16V11Z"
        fill="black"
      />
    </svg>
  );
};
export const Upload = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <rect width="24" height="24" rx="4" fillOpacity="0.3" />
      <path
        d="M14.2 11L18 16H6L9 12.1L11.1 14.8L14 11H14.2ZM8.5 11C9.3 11 10 10.3 10 9.5C10 8.7 9.3 8 8.5 8C7.7 8 7 8.7 7 9.5C7 10.3 7.7 11 8.5 11ZM22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6ZM20 8.8V6H4V18H20V8.8Z"
        fill="black"
      />
    </svg>
  );
};
export const More = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ddd_6454_54447)">
        <rect
          x="14"
          y="13"
          width="24"
          height="24"
          rx="8"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M26 21C27.1 21 28 20.1 28 19C28 17.9 27.1 17 26 17C24.9 17 24 17.9 24 19C24 20.1 24.9 21 26 21ZM26 23C24.9 23 24 23.9 24 25C24 26.1 24.9 27 26 27C27.1 27 28 26.1 28 25C28 23.9 27.1 23 26 23ZM26 29C24.9 29 24 29.9 24 31C24 32.1 24.9 33 26 33C27.1 33 28 32.1 28 31C28 29.9 27.1 29 26 29Z"
          fill="black"
          fillOpacity="0.54"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_6454_54447"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6454_54447"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_6454_54447"
            result="effect2_dropShadow_6454_54447"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_6454_54447"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_6454_54447"
            result="effect3_dropShadow_6454_54447"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_6454_54447"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const ArrowDown = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6L10.9425 4.9425L6.75 9.1275V0H5.25V9.1275L1.065 4.935L0 6L6 12L12 6Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const SalesRevenueIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 14.6328C15.2761 14.6328 15.5 14.409 15.5 14.1328C15.5 13.8567 15.2761 13.6328 15 13.6328C14.7239 13.6328 14.5 13.8567 14.5 14.1328C14.5 14.409 14.7239 14.6328 15 14.6328Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M3 6.13281V4.63281C3 4.3676 3.10536 4.11324 3.29289 3.92571C3.48043 3.73817 3.73478 3.63281 4 3.63281H8"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7.42505 7.55879L10.635 1.99879C10.7678 1.76956 10.9861 1.60238 11.242 1.53394C11.498 1.46551 11.7706 1.50142 12 1.63379L20.225 6.38379C20.339 6.44912 20.4389 6.53625 20.5192 6.6402C20.5994 6.74416 20.6584 6.8629 20.6928 6.98966C20.7271 7.11641 20.7362 7.24869 20.7194 7.37894C20.7026 7.50919 20.6604 7.63487 20.595 7.74879"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 8.63281H19.5C19.7652 8.63281 20.0196 8.73817 20.2071 8.92571C20.3946 9.11324 20.5 9.3676 20.5 9.63281V19.1328C20.5 19.398 20.3946 19.6524 20.2071 19.8399C20.0196 20.0275 19.7652 20.1328 19.5 20.1328H18.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17 10.6328V7.63281H1.5V20.6328H17V17.6328"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15 12.1328C14.7374 12.1328 14.4773 12.1845 14.2346 12.2851C13.992 12.3856 13.7715 12.5329 13.5858 12.7186C13.4001 12.9043 13.2528 13.1248 13.1522 13.3674C13.0517 13.6101 13 13.8702 13 14.1328C13 14.3955 13.0517 14.6555 13.1522 14.8982C13.2528 15.1408 13.4001 15.3613 13.5858 15.547C13.7715 15.7327 13.992 15.8801 14.2346 15.9806C14.4773 16.0811 14.7374 16.1328 15 16.1328H18V12.1328H15Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.5V17"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50002 12C9.00002 11 5.39002 10.8 5.50002 12.5C5.62002 14.33 10 13.035 10 15C10 16.35 7.00002 17 5.50002 15.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AttachFileIcon = (props) => {
  return (
    <svg
      width="11"
      height="22"
      viewBox="0 0 11 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 5V16.5C9.5 18.71 7.71 20.5 5.5 20.5C3.29 20.5 1.5 18.71 1.5 16.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V16.5C0 19.54 2.46 22 5.5 22C8.54 22 11 19.54 11 16.5V5H9.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const CheckIcon = (props) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.79508 10.8749L1.62508 6.70492L0.205078 8.11492L5.79508 13.7049L17.7951 1.70492L16.3851 0.294922L5.79508 10.8749Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ImageIcon = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2 7L16 12H4L7 8.1L9.1 10.8L12 7H12.2ZM6.5 7C7.3 7 8 6.3 8 5.5C8 4.7 7.3 4 6.5 4C5.7 4 5 4.7 5 5.5C5 6.3 5.7 7 6.5 7ZM20 2V14C20 15.1 19.1 16 18 16H2C0.9 16 0 15.1 0 14V2C0 0.9 0.9 0 2 0H18C19.1 0 20 0.9 20 2ZM18 4.8V2H2V14H18V4.8Z"
        fill="black"
      />
    </svg>
  );
};
export const MarkEmailUnreadIcon = ({ fillOpacity, fillClass, ...props }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 6.98V16C20 17.1 19.1 18 18 18H2C0.9 18 0 17.1 0 16V4C0 2.9 0.9 2 2 2H12.1C12.04 2.32 12 2.66 12 3C12 4.48 12.65 5.79 13.67 6.71L10 9L2 4V6L10 11L15.3 7.68C15.84 7.88 16.4 8 17 8C18.13 8 19.16 7.61 20 6.98ZM14 3C14 4.66 15.34 6 17 6C18.66 6 20 4.66 20 3C20 1.34 18.66 0 17 0C15.34 0 14 1.34 14 3Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.38"}
        className={fillClass}
      />
    </svg>
  );
};
export const EmailUnreadIcon = ({ fillOpacity, fillClass, ...props }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.38"}
        className={fillClass}
      />
    </svg>
  );
};
export const MarkEmailReadIcon = ({ fillOpacity, fillClass, ...props }) => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 15C10 11.13 13.13 8 17 8C18.08 8 19.09 8.25 20 8.68V2C20 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H10.08C10.03 15.67 10 15.34 10 15ZM2 2L10 7L18 2V4L10 9L2 4V2ZM15.34 18L11.8 14.46L13.21 13.05L15.33 15.17L19.57 10.93L21 12.34L15.34 18Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.38"}
        className={fillClass}
      />
    </svg>
  );
};
export const ArchiveIcon = ({ fillOpacity, fillClass, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.54 2.23L16.15 0.55C15.88 0.21 15.47 0 15 0H3C2.53 0 2.12 0.21 1.84 0.55L0.46 2.23C0.17 2.57 0 3.02 0 3.5V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V3.5C18 3.02 17.83 2.57 17.54 2.23ZM9 14.5L3.5 9H7V7H11V9H14.5L9 14.5ZM2.12 2L2.93 1H14.93L15.87 2H2.12Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.38"}
        className={fillClass}
      />
    </svg>
  );
};
export const Dash = () => {
  return (
    <svg
      className="w-3 h-3 text-theme"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 2"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1h16"
      />
    </svg>
  );
};
export const Increment = () => {
  return (
    <svg
      className="w-3 h-3 text-theme"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 1v16M1 9h16"
      />
    </svg>
  );
};
export const DeleteIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 32C2 34.21 3.79 36 6 36H22C24.21 36 26 34.21 26 32V8H2V32ZM28 2H21L19 0H9L7 2H0V6H28V2Z"
        {...props}
        fill="black"
      />
    </svg>
  );
};

export const LocalDirectorIcon = (props) => {
  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.9948 28.8333H31.9948C32.2158 28.8333 32.4278 28.7455 32.584 28.5893C32.7403 28.433 32.8281 28.221 32.8281 28V6.33333C32.8281 6.11232 32.7403 5.90036 32.584 5.74408C32.4278 5.5878 32.2158 5.5 31.9948 5.5H20.3281"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9974 28.8333H1.9974C1.77638 28.8333 1.56442 28.7455 1.40814 28.5893C1.25186 28.433 1.16406 28.221 1.16406 28V6.33333C1.16406 6.11232 1.25186 5.90036 1.40814 5.74408C1.56442 5.5878 1.77638 5.5 1.9974 5.5H13.6641"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 20.5C15.6763 20.5 14.3873 20.891 13.291 21.6235C12.1947 22.3561 11.3402 23.3973 10.8356 24.6154C10.331 25.8336 10.199 27.1741 10.4562 28.4673C10.7135 29.7605 11.3484 30.9484 12.2807 31.8807C13.2131 32.8131 14.401 33.448 15.6942 33.7052C16.9874 33.9625 18.3278 33.8304 19.546 33.3259C20.7642 32.8213 21.8054 31.9668 22.5379 30.8705C23.2705 29.7741 23.6615 28.4852 23.6615 27.1667C23.6615 25.3986 22.9591 23.7029 21.7088 22.4526C20.4586 21.2024 18.7629 20.5 16.9948 20.5Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.1036 19.5004C11.2149 19.0363 10.2215 18.8091 9.2193 18.8408C8.21714 18.8725 7.24007 19.162 6.38238 19.6813C5.52468 20.2006 4.81532 20.9322 4.32275 21.8055C3.83018 22.6788 3.57103 23.6644 3.57031 24.667"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 26.3346L16.1641 28.8346L20.3307 24.668"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3047 13.834H28.638"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20.3047 17.168H28.638"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.668V16.3346C12 16.9977 11.7366 17.6336 11.2678 18.1024C10.7989 18.5712 10.163 18.8346 9.5 18.8346C8.83696 18.8346 8.20107 18.5712 7.73223 18.1024C7.26339 17.6336 7 16.9977 7 16.3346V14.668H12Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 1.33398C17.8815 1.33398 18.7293 1.68517 19.3544 2.31029C19.9795 2.93542 20.3307 3.78326 20.3307 4.66732V8.00065H13.6641V4.66732C13.6641 3.78326 14.0153 2.93542 14.6404 2.31029C15.2655 1.68517 16.1133 1.33398 16.9974 1.33398Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 5.50065C17.4576 5.50065 17.8307 5.12755 17.8307 4.66732C17.8307 4.20708 17.4576 3.83398 16.9974 3.83398C16.5372 3.83398 16.1641 4.20708 16.1641 4.66732C16.1641 5.12755 16.5372 5.50065 16.9974 5.50065Z"
        fill="#065699"
      />
      <path
        d="M4.5 18.8346V14.668C4.5 13.3419 5.02678 12.0701 5.96447 11.1324C6.90215 10.1948 8.17392 9.66797 9.5 9.66797C10.8261 9.66797 12.0979 10.1948 13.0355 11.1324C13.9732 12.0701 14.5 13.3419 14.5 14.668V18.8346"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExpandLess = ({ pathClass, ...props }) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.294922L0 6.29492L1.41 7.70492L6 3.12492L10.59 7.70492L12 6.29492L6 0.294922Z"
        fill={"#44EFCC"}
        className={pathClass}
      />
    </svg>
  );
};
export const BankOpenIcon = (props) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.16406 6.99935L16.9974 1.16602L32.8307 6.99935V10.3327H1.16406V6.99935Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 7.83333C17.9153 7.83333 18.6615 7.08714 18.6615 6.16667C18.6615 5.24619 17.9153 4.5 16.9948 4.5C16.0743 4.5 15.3281 5.24619 15.3281 6.16667C15.3281 7.08714 16.0743 7.83333 16.9948 7.83333Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7.83333 10.332H4.5V22.832H7.83333V10.332Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15.3281 19.4987V10.332H18.6615V19.4987"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M29.4974 10.332H26.1641V22.832H29.4974V10.332Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 19.5C15.6763 19.5 14.3873 19.891 13.291 20.6235C12.1947 21.3561 11.3402 22.3973 10.8356 23.6154C10.331 24.8336 10.199 26.1741 10.4562 27.4673C10.7135 28.7605 11.3484 29.9484 12.2807 30.8807C13.2131 31.8131 14.401 32.448 15.6942 32.7052C16.9874 32.9625 18.3278 32.8304 19.546 32.3259C20.7642 31.8213 21.8054 30.9668 22.5379 29.8705C23.2705 28.7741 23.6615 27.4852 23.6615 26.1667C23.6615 24.3986 22.9591 22.7029 21.7088 21.4526C20.4586 20.2024 18.7629 19.5 16.9948 19.5Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 26.1497L16.9974 22.8164L20.3307 26.1497"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M17 30.3164V22.8164"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.2224 29.4993H1.16406V26.166H10.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M23.663 26.166H32.8297V29.4993H23.1797" fill="#065699" />
      <path
        d="M23.663 26.166H32.8297V29.4993H23.1797"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.3281 26.1654H2.82812V22.832H11.2198"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M22.7734 22.832H31.1651V26.1654H23.6651"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BankCloseIcon = (props) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.16406 6.99935L16.9974 1.16602L32.8307 6.99935V10.3327H1.16406V6.99935Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 7.83333C17.9153 7.83333 18.6615 7.08714 18.6615 6.16667C18.6615 5.24619 17.9153 4.5 16.9948 4.5C16.0743 4.5 15.3281 5.24619 15.3281 6.16667C15.3281 7.08714 16.0743 7.83333 16.9948 7.83333Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7.83333 10.332H4.5V22.832H7.83333V10.332Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15.3281 19.4987V10.332H18.6615V19.4987"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M29.4974 10.332H26.1641V22.832H29.4974V10.332Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 19.5C15.6763 19.5 14.3873 19.891 13.291 20.6235C12.1947 21.3561 11.3402 22.3973 10.8356 23.6154C10.331 24.8336 10.199 26.1741 10.4562 27.4673C10.7135 28.7605 11.3484 29.9484 12.2807 30.8807C13.2131 31.8131 14.401 32.448 15.6942 32.7052C16.9874 32.9625 18.3278 32.8304 19.546 32.3259C20.7642 31.8213 21.8054 30.9668 22.5379 29.8705C23.2705 28.7741 23.6615 27.4852 23.6615 26.1667C23.6615 24.3986 22.9591 22.7029 21.7088 21.4526C20.4586 20.2024 18.7629 19.5 16.9948 19.5Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20.3307 26.166L16.9974 29.591L13.6641 26.166"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M17 22V29.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.2224 29.4993H1.16406V26.166H10.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M23.663 26.166H32.8297V29.4993H23.1797" fill="#065699" />
      <path
        d="M23.663 26.166H32.8297V29.4993H23.1797"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.3281 26.1654H2.82812V22.832H11.2198"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M22.7734 22.832H31.1651V26.1654H23.6651"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CompanyIcon = (props) => {
  return (
    <svg
      width="34"
      height="36"
      viewBox="0 0 34 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.8307 15.5007L16.9974 1.33398L1.16406 15.5007"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M28.6615 26.334V34.6673H5.32812V26.334"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 27.168H8.66406V34.668H13.6641V27.168Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.3333 27.168H17V31.3346H25.3333V27.168Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 11.3333C18.8383 11.3333 20.3307 10.5871 20.3307 9.66667C20.3307 8.74619 18.8383 8 16.9974 8C15.1564 8 13.6641 8.74619 13.6641 9.66667C13.6641 10.5871 15.1564 11.3333 16.9974 11.3333Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.16406 15.5007V11.334"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M27.8281 15.5007V11.334"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.16406 15.5L3.66406 20.5H30.3307L27.8307 15.5H6.16406Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.3281 20.5L11.9948 15.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M22 15.5L23.6667 20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17 15.5V20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 20.5V21.3333C3.66406 22.2174 4.01525 23.0652 4.64037 23.6904C5.26549 24.3155 6.11334 24.6667 6.9974 24.6667C7.88145 24.6667 8.7293 24.3155 9.35442 23.6904C9.97954 23.0652 10.3307 22.2174 10.3307 21.3333V20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.3281 20.5V21.3333C10.3281 22.2174 10.6793 23.0652 11.3044 23.6904C11.9296 24.3155 12.7774 24.6667 13.6615 24.6667C14.5455 24.6667 15.3934 24.3155 16.0185 23.6904C16.6436 23.0652 16.9948 22.2174 16.9948 21.3333V20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17 20.5V21.3333C17 22.2174 17.3512 23.0652 17.9763 23.6904C18.6014 24.3155 19.4493 24.6667 20.3333 24.6667C21.2174 24.6667 22.0652 24.3155 22.6904 23.6904C23.3155 23.0652 23.6667 22.2174 23.6667 21.3333V20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.6641 20.5V21.3333C23.6641 22.2174 24.0153 23.0652 24.6404 23.6904C25.2655 24.3155 26.1133 24.6667 26.9974 24.6667C27.8815 24.6667 28.7293 24.3155 29.3544 23.6904C29.9795 23.0652 30.3307 22.2174 30.3307 21.3333V20.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BusinessActivitiesIcon = (props) => {
  return (
    <svg
      width="32"
      height="34"
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.4974 5.33268V2.83268C28.4974 2.39065 28.3218 1.96673 28.0092 1.65417C27.6967 1.34161 27.2728 1.16602 26.8307 1.16602H11.8307C11.3887 1.16602 10.9648 1.34161 10.6522 1.65417C10.3397 1.96673 10.1641 2.39065 10.1641 2.83268V5.33268"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.1641 30.3327V31.166C10.1641 31.608 10.3397 32.032 10.6522 32.3445C10.9648 32.6571 11.3887 32.8327 11.8307 32.8327H26.8307C27.2728 32.8327 27.6967 32.6571 28.0092 32.3445C28.3218 32.032 28.4974 31.608 28.4974 31.166V13.666"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.1641 5.33203L7.66406 10.332H30.9974L28.4974 5.33203H10.1641Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M14.3333 5.33203L13.5 10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M24.3359 5.33203L25.1693 10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M30.9974 10.332V11.582C30.9974 12.3556 30.6901 13.0974 30.1431 13.6444C29.5961 14.1914 28.8543 14.4987 28.0807 14.4987C27.3072 14.4987 26.5653 14.1914 26.0183 13.6444C25.4714 13.0974 25.1641 12.3556 25.1641 11.582V10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.1693 10.332V11.582C25.1693 12.3556 24.862 13.0974 24.315 13.6444C23.768 14.1914 23.0262 14.4987 22.2526 14.4987C21.4791 14.4987 20.7372 14.1914 20.1902 13.6444C19.6432 13.0974 19.3359 12.3556 19.3359 11.582V10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19.3333 10.332V11.582C19.3333 12.3556 19.026 13.0974 18.4791 13.6444C17.9321 14.1914 17.1902 14.4987 16.4167 14.4987C15.6431 14.4987 14.9013 14.1914 14.3543 13.6444C13.8073 13.0974 13.5 12.3556 13.5 11.582V10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13.4974 10.332V11.582C13.4974 12.3556 13.1901 13.0974 12.6431 13.6444C12.0961 14.1914 11.3543 14.4987 10.5807 14.4987C9.80718 14.4987 9.06532 14.1914 8.51833 13.6444C7.97135 13.0974 7.66406 12.3556 7.66406 11.582V10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19.3359 5.33203V10.332"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.1641 14.5V17"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.8359 26.166H28.5026"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3359 18.666H26.0026"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19.3359 22H26.0026"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.1667 30.3333C13.8486 30.3333 16.8333 27.3486 16.8333 23.6667C16.8333 19.9848 13.8486 17 10.1667 17C6.48477 17 3.5 19.9848 3.5 23.6667C3.5 27.3486 6.48477 30.3333 10.1667 30.3333Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5.16667 28.666L1 32.8327"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3333 30.3327C19.7936 30.3327 20.1667 29.9596 20.1667 29.4993C20.1667 29.0391 19.7936 28.666 19.3333 28.666C18.8731 28.666 18.5 29.0391 18.5 29.4993C18.5 29.9596 18.8731 30.3327 19.3333 30.3327Z"
        fill="#065699"
      />
    </svg>
  );
};
export const RegisteredAddressIcon = (props) => {
  return (
    <svg
      width="30"
      height="35"
      viewBox="0 0 30 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3333 22H10V27.8333H13.3333V22Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20.0052 22H16.6719V25.3333H20.0052V22Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20 16.166V16.9993C20 17.6624 20.2634 18.2983 20.7322 18.7671C21.2011 19.236 21.837 19.4993 22.5 19.4993C23.163 19.4993 23.7989 19.236 24.2678 18.7671C24.7366 18.2983 25 17.6624 25 16.9993V16.166"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15 16.166V16.9993C15 17.6624 15.2634 18.2983 15.7322 18.7671C16.2011 19.236 16.837 19.4993 17.5 19.4993C18.163 19.4993 18.7989 19.236 19.2678 18.7671C19.7366 18.2983 20 17.6624 20 16.9993V16.166"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10 16.166V16.9993C10 17.6624 10.2634 18.2983 10.7322 18.7671C11.2011 19.236 11.837 19.4993 12.5 19.4993C13.163 19.4993 13.7989 19.236 14.2678 18.7671C14.7366 18.2983 15 17.6624 15 16.9993V16.166"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 16.166V16.9993C5 17.6624 5.26339 18.2983 5.73223 18.7671C6.20107 19.236 6.83696 19.4993 7.5 19.4993C8.16304 19.4993 8.79893 19.236 9.26777 18.7671C9.73661 18.2983 10 17.6624 10 16.9993V16.166"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 12.832L5 16.1654H25L23.3333 12.832H6.66667Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10 16.1654L10.8333 12.832"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15 16.1654V12.832"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20.0052 16.1654L19.1719 12.832"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.3385 21.166V27.8327H6.67188V21.166"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M14.8363 6.2818C14.8477 6.24648 14.8699 6.21566 14.8998 6.1938C14.9298 6.17194 14.9659 6.16016 15.003 6.16016C15.0401 6.16016 15.0762 6.17194 15.1062 6.1938C15.1361 6.21566 15.1584 6.24648 15.1697 6.2818L15.603 7.62346H17.0113C17.0475 7.62428 17.0827 7.6358 17.1123 7.65656C17.142 7.67732 17.1649 7.7064 17.178 7.74013C17.1901 7.77618 17.1902 7.81521 17.1782 7.8513C17.1661 7.88738 17.1427 7.91857 17.1113 7.94013L15.978 8.77346L16.4113 10.1151C16.4229 10.15 16.4226 10.1876 16.4105 10.2223C16.3985 10.2569 16.3753 10.2866 16.3447 10.3068C16.3153 10.3272 16.2804 10.3382 16.2447 10.3382C16.2089 10.3382 16.174 10.3272 16.1447 10.3068L15.003 9.49846L13.8613 10.3318C13.832 10.3522 13.7971 10.3632 13.7613 10.3632C13.7256 10.3632 13.6907 10.3522 13.6613 10.3318C13.6334 10.3093 13.6123 10.2794 13.6006 10.2455C13.5888 10.2116 13.5867 10.1751 13.5947 10.1401L14.0363 8.79846L12.8947 7.96513C12.8643 7.9427 12.8417 7.91146 12.8297 7.87567C12.8178 7.83988 12.8172 7.80128 12.828 7.76513C12.8412 7.7314 12.864 7.70232 12.8937 7.68156C12.9233 7.6608 12.9585 7.64928 12.9947 7.64846H14.403L14.8363 6.2818Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.17373 6.2818C8.18503 6.24648 8.20727 6.21566 8.23723 6.1938C8.26718 6.17194 8.30331 6.16016 8.34039 6.16016C8.37748 6.16016 8.4136 6.17194 8.44356 6.1938C8.47352 6.21566 8.49575 6.24648 8.50706 6.2818L8.94039 7.62346H10.3487C10.3849 7.62428 10.4201 7.6358 10.4497 7.65656C10.4794 7.67732 10.5022 7.7064 10.5154 7.74013C10.5275 7.77618 10.5276 7.81521 10.5156 7.8513C10.5035 7.88738 10.4801 7.91857 10.4487 7.94013L9.30706 8.77346L9.74873 10.1151C9.75828 10.1496 9.75702 10.1862 9.74512 10.22C9.73323 10.2537 9.71127 10.283 9.6822 10.3039C9.65314 10.3248 9.61837 10.3363 9.58258 10.3368C9.5468 10.3373 9.51171 10.3268 9.48206 10.3068L8.34039 9.49846L7.19873 10.3318C7.16907 10.3518 7.13399 10.3623 7.0982 10.3618C7.06241 10.3613 7.02764 10.3498 6.99858 10.3289C6.96952 10.308 6.94756 10.2787 6.93566 10.245C6.92377 10.2112 6.92251 10.1746 6.93206 10.1401L7.37373 8.79846L6.23206 7.96513C6.20072 7.94357 6.17726 7.91238 6.16523 7.8763C6.1532 7.84021 6.15326 7.80118 6.16539 7.76513C6.17855 7.7314 6.2014 7.70232 6.23106 7.68156C6.26072 7.6608 6.29586 7.64928 6.33206 7.64846H7.74039L8.17373 6.2818Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5019 6.2818C21.5132 6.24648 21.5354 6.21566 21.5654 6.1938C21.5953 6.17194 21.6314 6.16016 21.6685 6.16016C21.7056 6.16016 21.7417 6.17194 21.7717 6.1938C21.8016 6.21566 21.8239 6.24648 21.8352 6.2818L22.2685 7.62346H23.6769C23.713 7.62428 23.7482 7.6358 23.7779 7.65656C23.8075 7.67732 23.8304 7.7064 23.8435 7.74013C23.8557 7.77618 23.8557 7.81521 23.8437 7.8513C23.8317 7.88738 23.8082 7.91857 23.7769 7.94013L22.6352 8.77346L23.0769 10.1151C23.0864 10.1496 23.0851 10.1862 23.0732 10.22C23.0614 10.2537 23.0394 10.283 23.0103 10.3039C22.9813 10.3248 22.9465 10.3363 22.9107 10.3368C22.8749 10.3373 22.8398 10.3268 22.8102 10.3068L21.6685 9.49846L20.5269 10.3318C20.4972 10.3518 20.4621 10.3623 20.4263 10.3618C20.3905 10.3613 20.3558 10.3498 20.3267 10.3289C20.2976 10.308 20.2757 10.2787 20.2638 10.245C20.2519 10.2112 20.2506 10.1746 20.2602 10.1401L20.7019 8.79846L19.5602 7.96513C19.5288 7.94357 19.5054 7.91238 19.4934 7.8763C19.4813 7.84021 19.4814 7.80118 19.4935 7.76513C19.5067 7.7314 19.5295 7.70232 19.5592 7.68156C19.5888 7.6608 19.624 7.64928 19.6602 7.64846H21.0685L21.5019 6.2818Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8949 24.7744C25.292 23.4987 26.4045 21.9429 27.1598 20.2083C27.9151 18.4738 28.2962 16.5995 28.2782 14.7077C28.239 11.1741 26.836 7.79237 24.3622 5.26889C21.8885 2.74541 18.5353 1.27542 15.0032 1.16602C13.2395 1.17352 11.4948 1.53086 9.87014 2.21736C8.2455 2.90386 6.7732 3.90587 5.53852 5.16535C4.30384 6.42484 3.33131 7.91677 2.67726 9.55474C2.0232 11.1927 1.70062 12.9442 1.72819 14.7077C1.81638 18.4746 3.36408 22.0599 6.04486 24.7077"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.17188 27.832L15.0052 33.6654L20.8385 27.832"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ParticularsIcon = (props) => {
  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.9948 28.8333H31.9948C32.2158 28.8333 32.4278 28.7455 32.584 28.5893C32.7403 28.433 32.8281 28.221 32.8281 28V6.33333C32.8281 6.11232 32.7403 5.90036 32.584 5.74408C32.4278 5.5878 32.2158 5.5 31.9948 5.5H20.3281"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9974 28.8333H1.9974C1.77638 28.8333 1.56442 28.7455 1.40814 28.5893C1.25186 28.433 1.16406 28.221 1.16406 28V6.33333C1.16406 6.11232 1.25186 5.90036 1.40814 5.74408C1.56442 5.5878 1.77638 5.5 1.9974 5.5H13.6641"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9948 20.5C15.6763 20.5 14.3873 20.891 13.291 21.6235C12.1947 22.3561 11.3402 23.3973 10.8356 24.6154C10.331 25.8336 10.199 27.1741 10.4562 28.4673C10.7135 29.7605 11.3484 30.9484 12.2807 31.8807C13.2131 32.8131 14.401 33.448 15.6942 33.7052C16.9874 33.9625 18.3278 33.8304 19.546 33.3259C20.7642 32.8213 21.8054 31.9668 22.5379 30.8705C23.2705 29.7741 23.6615 28.4852 23.6615 27.1667C23.6615 25.3986 22.9591 23.7029 21.7088 22.4526C20.4586 21.2024 18.7629 20.5 16.9948 20.5Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.1036 19.5004C11.2149 19.0363 10.2215 18.8091 9.2193 18.8408C8.21714 18.8725 7.24007 19.162 6.38238 19.6813C5.52468 20.2006 4.81532 20.9322 4.32275 21.8055C3.83018 22.6788 3.57103 23.6644 3.57031 24.667"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 26.3346L16.1641 28.8346L20.3307 24.668"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3047 13.834H28.638"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20.3047 17.168H28.638"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.668V16.3346C12 16.9977 11.7366 17.6336 11.2678 18.1024C10.7989 18.5712 10.163 18.8346 9.5 18.8346C8.83696 18.8346 8.20107 18.5712 7.73223 18.1024C7.26339 17.6336 7 16.9977 7 16.3346V14.668H12Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 1.33398C17.8815 1.33398 18.7293 1.68517 19.3544 2.31029C19.9795 2.93542 20.3307 3.78326 20.3307 4.66732V8.00065H13.6641V4.66732C13.6641 3.78326 14.0153 2.93542 14.6404 2.31029C15.2655 1.68517 16.1133 1.33398 16.9974 1.33398Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 5.50065C17.4576 5.50065 17.8307 5.12755 17.8307 4.66732C17.8307 4.20708 17.4576 3.83398 16.9974 3.83398C16.5372 3.83398 16.1641 4.20708 16.1641 4.66732C16.1641 5.12755 16.5372 5.50065 16.9974 5.50065Z"
        fill="#065699"
      />
      <path
        d="M4.5 18.8346V14.668C4.5 13.3419 5.02678 12.0701 5.96447 11.1324C6.90215 10.1948 8.17392 9.66797 9.5 9.66797C10.8261 9.66797 12.0979 10.1948 13.0355 11.1324C13.9732 12.0701 14.5 13.3419 14.5 14.668V18.8346"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const YearEndIcon = (props) => {
  return (
    <svg
      width="34"
      height="25"
      viewBox="0 0 34 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.16667 4.66732V1.33398H32.8333V23.834H4.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16406 4.66797V21.3346C1.16406 21.9977 1.42745 22.6336 1.8963 23.1024C2.36514 23.5712 3.00102 23.8346 3.66406 23.8346C4.3271 23.8346 4.96299 23.5712 5.43183 23.1024C5.90067 22.6336 6.16406 21.9977 6.16406 21.3346V4.66797H1.16406Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6667 13.0013C15.9679 13.0013 17.8333 11.1358 17.8333 8.83464C17.8333 6.53345 15.9679 4.66797 13.6667 4.66797C11.3655 4.66797 9.5 6.53345 9.5 8.83464C9.5 11.1358 11.3655 13.0013 13.6667 13.0013Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 16.3333C10.6667 16.5174 10.5174 16.6667 10.3333 16.6667C10.1492 16.6667 10 16.5174 10 16.3333C10 16.1492 10.1492 16 10.3333 16C10.5174 16 10.6667 16.1492 10.6667 16.3333Z"
        fill="#065699"
        stroke="#065699"
      />
      <path
        d="M13.9948 16.3333C13.9948 16.5174 13.8456 16.6667 13.6615 16.6667C13.4774 16.6667 13.3281 16.5174 13.3281 16.3333C13.3281 16.1492 13.4774 16 13.6615 16C13.8456 16 13.9948 16.1492 13.9948 16.3333Z"
        fill="#065699"
        stroke="#065699"
      />
      <path
        d="M17.3307 16.3333C17.3307 16.5174 17.1815 16.6667 16.9974 16.6667C16.8133 16.6667 16.6641 16.5174 16.6641 16.3333C16.6641 16.1492 16.8133 16 16.9974 16C17.1815 16 17.3307 16.1492 17.3307 16.3333Z"
        fill="#065699"
        stroke="#065699"
      />
      <path
        d="M21.1641 6.33398H30.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.1641 9.66797H30.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 9.66797H6.16406"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 12.9844H6.16406"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 16.3086H6.16406"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 19.625H6.16406"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.1641 13H30.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.1641 16.334H30.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.1641 19.668H30.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 19.668H18.6667"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 4.66797V8.83463H17.8307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ShareholdersIcon = (props) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.16406 24.4994H1.9974C1.77638 24.4994 1.56442 24.4116 1.40814 24.2553C1.25186 24.099 1.16406 23.887 1.16406 23.666V1.99935C1.16406 1.77834 1.25186 1.56637 1.40814 1.41009C1.56442 1.25381 1.77638 1.16602 1.9974 1.16602H31.9974C32.2184 1.16602 32.4304 1.25381 32.5867 1.41009C32.7429 1.56637 32.8307 1.77834 32.8307 1.99935V23.666C32.8307 23.887 32.7429 24.099 32.5867 24.2553C32.4304 24.4116 32.2184 24.4994 31.9974 24.4994H27.8307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.9974 15.332C15.3492 15.332 13.7381 15.8208 12.3676 16.7365C10.9972 17.6521 9.92913 18.9536 9.2984 20.4763C8.66767 21.9991 8.50265 23.6746 8.82419 25.2911C9.14573 26.9076 9.93941 28.3925 11.1048 29.5579C12.2703 30.7234 13.7551 31.517 15.3716 31.8386C16.9882 32.1601 18.6637 31.9951 20.1864 31.3644C21.7091 30.7336 23.0106 29.6655 23.9263 28.2951C24.842 26.9247 25.3307 25.3135 25.3307 23.6654C25.3307 21.4552 24.4528 19.3356 22.89 17.7728C21.3272 16.21 19.2075 15.332 16.9974 15.332Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.8281 22.6243L15.9531 25.7493L21.1615 20.541"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.32812 5.33203V10.332H10.3281V5.33203H5.32812Z"
        fill="#065699"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.32812 20.332H9.03646"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9531 20.332H28.6615"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.32812 17H9.03646"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9531 17H28.6615"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 6.16602H15.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6641 6.16602H20.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6641 6.16602H25.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1641 9.5H25.3307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 9.5H17.8307"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownloadIcon = (props) => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.8333 6H10.8333V0H4.83325V6H0.833252L7.83325 13L14.8333 6ZM0.833252 15V17H14.8333V15H0.833252Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
